<script type="text/ecmascript-6">
    import DesignerQuestionDoorOpeningDirection from "./DesignerQuestionDoorOpeningDirection.vue";
    import RadioSwitchQuestion from "../mixin/RadioSwitchQuestion.vue";

    export default {
        mixins: [
            DesignerQuestionDoorOpeningDirection,
            RadioSwitchQuestion,
        ],
        props: {
            title: {
                default() {
                    return 'Opening Direction: <small>(viewed from outside)</small>';
                }
            }
        }
    }
</script>
